











































import { Component, Prop, Vue } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import EditButton from '../EditButton.vue'
import PaymentMethodPopup from '@/components/EditOrderDetail/PaymentMethodPopup.vue'
import PricePopup from '@/components/EditOrderDetail/PricePopup.vue'
import UserPopup from '@/components/EditOrderDetail/UserPopup.vue'
import MenuPopup from '@/components/EditOrderDetail/MenuPopup.vue'
import CouponPopup from '@/components/EditOrderDetail/CouponPopup.vue'

library.add(faEdit);

enum fieldType {
  paymentMethod = 'paymentMethod',
  totalSales = 'totalSales',
  user = 'user',
  menu = 'menu',
  coupon = 'coupon',
}

@Component({
  components: {
    EditButton,
    PaymentMethodPopup,
    PricePopup,
    UserPopup,
    MenuPopup,
    CouponPopup,
  }
})
export default class EditOrderDetail extends Vue {
  @Prop({ default: 'paymentMethod' }) field?: fieldType;
  @Prop({ default: () => {} }) data?: any;

  showPaymentMethodModal: boolean = false;
  showTotalSalesModal: boolean = false;
  showUserModal: boolean = false;
  showMenuModal: boolean = false;
  showCouponModal: boolean = false;

  editOrderDetail() {
    if (this.field === 'paymentMethod') {
      this.showPaymentMethodModal = true;
    } else if (this.field === 'totalSales') {
      this.showTotalSalesModal = true;
    } else if (this.field === 'user') {
      this.showUserModal = true;
    } else if (this.field === 'menu') {
      this.showMenuModal = true;
    } else if (this.field === 'coupon') {
      this.showCouponModal = true;
    }
  }

  handleSaveCallback(payload) {
    this.$emit('call-back', payload);
  }

  handleSavePaymentMethod(payload) {
    this.showPaymentMethodModal = false;
    this.handleSaveCallback(payload);
  }

  handleSaveTotalSales(payload) {
    this.showTotalSalesModal = false;
    this.handleSaveCallback(payload);
  }

  handleSaveUser(payload) {
    this.showUserModal = false;
    this.handleSaveCallback(payload);
  }

  handleSaveMenu(payload) {
    this.showMenuModal = false;
    this.handleSaveCallback(payload);
  }

  handleSaveCoupon(payload) {
    this.showCouponModal = false;
    this.handleSaveCallback(payload);
  }
}
